import React from 'react';
import { useOffline } from '../hooks/useOffline';
import './OfflineIndicator.css';

export const OfflineIndicator: React.FC = () => {
  const [offlineState] = useOffline();

  if (offlineState.isOnline) {
    return null; // Don't show anything when online
  }

  return (
    <div className="offline-indicator">
      <div className="offline-indicator__content">
        <span className="offline-indicator__icon">📶</span>
        <span className="offline-indicator__text">
          Offline Mode - Single Player Available
        </span>
        {offlineState.offlineGamesCount > 0 && (
          <span className="offline-indicator__games">
            ({offlineState.offlineGamesCount} saved games)
          </span>
        )}
      </div>
    </div>
  );
};